module.exports = __webpack_public_path__ + "img/44.38889cec.jpg";